// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainerForPage":"_1QRM0IL","spinner":"_2IeIT18","sk-stretchdelay":"_3wyYr_P","rect2":"b6Zv8AA","rect3":"q0OLOxq","rect4":"_20A1mZe","rect5":"_3u-NHkR"};